module.exports = __webpack_public_path__ + "img/tmh-tc-140x100.790c9361.jpg";